<template>
  <div class="analytics">
    <div class="audit-global-range">
      <global-range />
    </div>

    <views v-if="active"/>
    <involvement-plotly v-if="active" />
    <div class="sex" v-if="active">
      <age />
      <sex />
    </div>
    <div class="geo" v-if="active">
      <geo />
      <union-city />
    </div>
    <summary-likes-and-reposts v-if="active"/>
<!--    <audience v-if="active"/>-->
  </div>
</template>

<script>
  /*audit component from tabs directory of analytics with charts*/

  // components
  import Views from "./components/Views";
  import Audience from "./components/Audience";
  import Involvement from "./components/Involvement";
  import InvolvementPlotly from "./components/InvolvementPlotly";
  import SummaryLikesAndReposts from "./components/SummaryLikesAndReposts";
  import Age from "./components/Age";
  import Sex from "./components/Sex";
  import Geo from "./components/Geo";
  import UnionCity from "./components/UnionCity";
  import GlobalRange from "../../../../../../components/auditPeriodRange/GlobalPeriodRange";

  export default {
    name: "Audit",
    props: {
      active: {
        type: Boolean
      }
    },
    components: {
      Views,
      Audience,
      InvolvementPlotly,
      SummaryLikesAndReposts,
      GlobalRange,
      Age,
      Sex,
      Geo,
      UnionCity,
    }
  };
</script>

<style>
  .analytics {
    padding-top: 29px;
  }

  .audit-global-range {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
    margin-right: 20px;
  }

  .sex, .geo {
    display: flex;
  }

  @media screen and (max-width: 480px) {
      .sex, .geo {
        display: block;
      }
  }

</style>
